"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.registration = registration;
exports.confirmRegistration = confirmRegistration;
exports.registrationOneClick = registrationOneClick;
exports.confirmRegistrationOneClick = confirmRegistrationOneClick;
exports.resetStep = resetStep;
exports.resetError = resetError;
exports.sendVoiceCode = sendVoiceCode;
exports.resetVoiceCode = resetVoiceCode;

var _constants = require('../constants/');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function registration(_ref) {
    var password = _ref.password,
        shopId = _ref.shopId,
        params = (0, _objectWithoutProperties3.default)(_ref, ['password', 'shopId']);

    return {
        types: [_constants.RegistrationConstants.REGISTRATION_FORM_REQUEST, _constants.RegistrationConstants.REGISTRATION_FORM_SUCCESS, _constants.RegistrationConstants.REGISTRATION_FORM_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.userRegistration(password, shopId, params);
        }
    };
}

function confirmRegistration(_ref2) {
    var password = _ref2.password,
        shopId = _ref2.shopId,
        params = (0, _objectWithoutProperties3.default)(_ref2, ['password', 'shopId']);

    return {
        types: [_constants.RegistrationConstants.REGISTRATION_CONFIRM_REQUEST, _constants.RegistrationConstants.REGISTRATION_CONFIRM_SUCCESS, _constants.RegistrationConstants.REGISTRATION_CONFIRM_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.userConfirmRegistration(password, shopId, params);
        }
    };
}

function registrationOneClick(_ref3) {
    var shopId = _ref3.shopId,
        params = (0, _objectWithoutProperties3.default)(_ref3, ['shopId']);

    return {
        types: [_constants.AuthConstants.LOGIN, _constants.AuthConstants.ONE_CLICK_SUCCESS, _constants.AuthConstants.LOGIN_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.userRegistrationOneClick(shopId, params);
        }
    };
}

function confirmRegistrationOneClick(_ref4) {
    var shopId = _ref4.shopId,
        params = (0, _objectWithoutProperties3.default)(_ref4, ['shopId']);

    return {
        types: [_constants.AuthConstants.LOGIN, _constants.AuthConstants.LOGIN_SUCCESS, _constants.AuthConstants.ONE_CLICK_CONFIRM_ERROR],
        promise: function promise(client, iBonus) {
            return iBonus.userConfirmRegistrationOneClick(shopId, params);
        }
    };
}

function resetStep() {
    return {
        type: _constants.RegistrationConstants.REGISTRATION_RESET_STEP
    };
}

function resetError() {
    return {
        type: _constants.RegistrationConstants.REGISTRATION_RESET_ERROR
    };
}

function sendVoiceCode(phone) {
    var source = 'registration';
    return {
        types: [_constants.RegistrationConstants.REGISTRATION_VOICE_FORM_REQUEST, _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_SUCCESS, _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.sendVoiceCode(phone, source);
        }
    };
}

function resetVoiceCode() {
    return {
        type: _constants.RegistrationConstants.REGISTRATION_VOICE_RESET
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/registration.js
// module id = 194
// module chunks = 0